import { combineReducers } from "redux";

import {
    ConfigState as PayoutMerchantConfigState,
    reducer as payoutConfig,
    namespace as payoutConfigNamespace,
} from "./payout/merchant/config/actions";

export interface State {
    [payoutConfigNamespace]: PayoutMerchantConfigState;
}

export const initialState: State = {
    [payoutConfigNamespace]: payoutConfig(undefined, { type: "@@INIT" }),
};

export const reducer = combineReducers<State>({
    [payoutConfigNamespace]: payoutConfig,
});

declare module "react-redux" {
    interface DefaultRootState extends State {}
}
